import type { PayloadAction } from '@reduxjs/toolkit';

import type { IShoppingCart } from './models';

export const UPDATE = 'shoppingCart/update';
export function updateShoppingCart(payload: IShoppingCart)
: PayloadAction<IShoppingCart> {
  return {
    type: UPDATE,
    payload,
  };
}

